import { Component, Inject, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent {
  user: any;

  @Input()
  showToggle: boolean = true;

  @Input()
  showSignin: boolean = true;

  isPathCorrect = location.pathname != '/manage-sites' && location.pathname != '/indexing-history' && location.pathname != '/service-accounts';


  constructor(@Inject(DOCUMENT) private document: Document, private authService: AuthService, private router: Router) {

    router.events.subscribe((val) => {

      this.isPathCorrect = location.pathname != '/manage-sites' && location.pathname != '/indexing-history' && location.pathname != '/service-accounts';
    });

  }

  ngOnInit() {

    var userToken = localStorage.getItem("ut");

    if (userToken != null) {
      let parsedJwt = this.parseJwt(userToken);

      this.user = {
        name: parsedJwt.unique_name,
        photoUrl: parsedJwt.ProfilePicture
      };

    }
  }

  onSidebarToggleClicked() {

    if (this.document.body.classList.contains("toggle-sidebar"))
      this.document.body.classList.remove('toggle-sidebar');
    else
      this.document.body.classList.add('toggle-sidebar');
  }

  signOut() {
    this.authService.signOut();
  }

  scroll(id: string) {

    let el = document.getElementById(id);
    el?.scrollIntoView({ behavior: 'smooth' });
  }

  parseJwt(token: any) {
    var base64Url = token.split('.')[1];
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    var jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function (c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));

    return JSON.parse(jsonPayload);
  }
}
